import loadInitialConversationsFromServer from './helpers/loadInitialConversationsFromServer';
import loadInitialItemsFromServer from './helpers/loadInitialItemsFromServer';
import { LoadErrorStatus, TableView } from 'owa-mail-list-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { OnInitialTableLoadComplete } from 'owa-mail-loading-action-types';

/**
 * @param tableView to load rows in
 * @param OnInitialTableLoadComplete is a callback that is called when we receive the response
 * The callback is handled by table loading
 * @param isTablePrefetched indicates if the table is prefetched
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialRowsFromServer')(function loadInitialRowsFromServer(
    tableView: TableView,
    isTablePrefetched: boolean,
    onInitialTableLoadComplete: OnInitialTableLoadComplete
): Promise<void> {
    tableView.isLoading = true;
    tableView.loadErrorStatus = LoadErrorStatus.None;

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            return loadInitialConversationsFromServer(
                tableView,
                isTablePrefetched,
                onInitialTableLoadComplete
            );

        case ReactListViewType.Message:
            return loadInitialItemsFromServer(
                tableView,
                isTablePrefetched,
                onInitialTableLoadComplete
            );

        default:
            trace.warn('listViewType: ' + tableView.tableQuery.listViewType + ' is not supported.');
            return Promise.resolve();
    }
});
